import {RouterView} from '../RouterView.js';
import Admin from '../../components/views/administration/Index';
import User from './User';
import Catalogs from "./Catalogs";
import Templates from "./Templates";
import PermissionProfile from "./PermissionProfile";
import Forms from "./Forms";
import Utils from './Categories';
import Rules from "../../components/views/administration/users/partials/Rules";
import Dates from "../../components/views/administration/Dates";
import Counts from "../../components/partials/Counts";
import NotFound from "../../components/views/panel/partials/NotFound";

export default {
    path: "administracion",
    component: RouterView,
    children: [
        {
            path: '',
            component: Admin,
            meta: {
                auth: true,
            }
        },
        {
          path:'rules',
          component: Rules,
          meta:{
              auth: true
          }
        },
        {
          path:'periodos',
          component: Dates,
          meta:{
              auth: true
          }
        },
        {
          path:'counts',
          component: Counts,
          meta:{
              auth: true
          }
        },
        {...Utils},
        {...User},
        {...Catalogs},
        {...Templates},
        {...PermissionProfile},
        {...Forms},

    ]
}
